import React from 'react'
import { FormattedMessage } from 'react-intl'
import CheckboxGroup from 'components/CheckboxGroup'

import messages from './messages'
import styles from './LocationsSection.scss'

// const businessLocationsStub = [
//   'Am Grauen Stein, 51105 Cologne',
//   '182 Dougharty Road, Heidelberg West, Melbourne, Victoria, 3081',
//   'Jalan Rangkayo Rasuna Said, Jakarta Capital Region, Jakarta',
//   'Jalan Para U8/103, Shah Alam, 40150 Petaling, Selangor',
//   'Don Bosco & Chino Roces Avenue, Makati City, National Capital Region, 1230',
//   'Soi Pun Na Withi 36 & Soi Pun Na Withi 38, Bangkok, Bangkok, 10260',
//   'Alboinstraße 56, 12103 Berlin',
//   'Tillystraße 2, 90431 Nuremberg',
//   '11 Pun Shan Street, Tsuen Wan District',
//   'Taipei City Songshan District Bade Road Section 4 4',
//   'Cairo-Aswan Agricultural Road 11, Malawy',
//   'Boulevard El Kettar Algeria, Algeria 16017',
//   '3 Rue de la Mer du Nord, Casablanca, Grand Casablanca, 20180',
//   'Al Andalus Street, Makkah Al Mukarramah Province, Jeddah',
//   'Manus Gerber Street, Goodwood, City of Cape Town, Western Cape, 7460',
//   'Koranna Avenue 92, Centurion, City of Tshwane, Gauteng, 0157',
//   'Mubarak Bin Mohammed Street, Abu Dhabi, Abu Dhabi',
//   'ulitsa Triaditsa 5, 1000 Sofia',
//   'Komitetu Obrony Robotników, Warsaw',
//   '125167, Moscow, Leningradskiy prospekt, 3',
//   'Ulica Kosovska 10, Belgrade, 11211',
//   'Pekařská 7, 15500 Prague',
//   'Váci út 48b, 1132 Budapest',
//   'Avenida Santa Fe, 01376, Mexico City',
//   '46991 5 Mile Road, Plymouth, MI 48170',
//   '1200 Sheppard Avenue East, North York, ON M2K',
//   'Rua dos Comerciários 220, 04320-030, São Paulo',
//   'Avenida Holanda 100, 7510040 Santiago, Santiago Metropolitan Region',
//   'Calle 108 15-45 Bogotá, Distrito Capital, 110111',
//   'Avenida Felipe Pardo y Aliaga San Isidro Lima, Lima, 15073',
//   'Rue Montoyer 47, 1000 Brussels',
//   'Chemin Saint-Éloy, Paris, 75018',
//   'Lower Road & Ashwood Park, Leatherhead, KT22',
//   'Via Mattei, 3, 20018 Sedriano',
//   'Rue Edmond Reuter 24, Contern, L-5326',
//   'Arthur van Schendelstraat 600, 3511 MJ, Utrecht',
//   'Calle del Bruc 94, 08009 Barcelona',
//   'Avenida de Burgos 3, 28016 Madrid',
//   'Worblaufenstrasse 6, 3048 Berne',
//   'Mobilvägen 10, 22362 Lund',
//   "Rue de Quesnoy & Boulevard de l'Alliance Nord-Ouest, Marquette-lez-Lille, 59520",
//   'Lal Bahadur Shastri Marg, New Delhi, Delhi, 110051',
//   'Peruri Auzoa 1, 48940 Leioa',
//   '2029 Stierlin Court, Mountain View, CA 94043',
//   'Microsoft Way, Redmond, WA 98052',
//   '1355 Market Street, San Francisco, CA 94103',
//   '808 Brannan Street, San Francisco, CA 94103',
//   'North Rengstorff Avenue, Mountain View, CA 94043',
//   '1601 South California Avenue, Palo Alto, CA 94304',
//   '1601 Willow Road, Menlo Park, CA 94025'
// ];
//
// const enrichedBusinessLocationsStub = [
//   { originalLocation: 'Germany', count: 3 },
//   { originalLocation: 'Australia', count: 1 },
//   { originalLocation: 'Indonesia', count: 1 },
//   { originalLocation: 'Malaysia', count: 1 },
//   { originalLocation: 'Philippines', count: 1 },
//   { originalLocation: 'Thailand', count: 1 },
//   { originalLocation: 'Hong Kong', count: 1 },
//   { originalLocation: 'Taiwan', count: 1 },
//   { originalLocation: 'Egypt', count: 1 },
//   { originalLocation: 'Algeria', count: 1 },
//   { originalLocation: 'Morocco', count: 1 },
//   { originalLocation: 'Saudi Arabia', count: 1 },
//   { originalLocation: 'South Africa', count: 2 },
//   { originalLocation: 'United Arab Emirates', count: 1 },
//   { originalLocation: 'Bulgaria', count: 1 },
//   { originalLocation: 'Poland', count: 1 },
//   { originalLocation: 'Russia', count: 1 },
//   { originalLocation: 'Serbia', count: 1 },
//   { originalLocation: 'Czechia', count: 1 },
//   { originalLocation: 'Hungary', count: 1 },
//   { originalLocation: 'Mexico', count: 1 },
//   { originalLocation: 'US/Michigan', count: 1 },
//   { originalLocation: 'Canada', count: 1 },
//   { originalLocation: 'Brazil', count: 1 },
//   { originalLocation: 'Chile', count: 1 },
//   { originalLocation: 'Colombia', count: 1 },
//   { originalLocation: 'Peru', count: 1 },
//   { originalLocation: 'Belgium', count: 1 },
//   { originalLocation: 'France', count: 2 },
//   { originalLocation: 'United Kingdom', count: 1 },
//   { originalLocation: 'Italy', count: 1 },
//   { originalLocation: 'Luxembourg', count: 1 },
//   { originalLocation: 'Netherlands', count: 1 },
//   { originalLocation: 'ES/Barcelona', count: 1 },
//   { originalLocation: 'ES/Madrid', count: 1 },
//   { originalLocation: 'Switzerland', count: 1 },
//   { originalLocation: 'Sweden', count: 1 },
//   { originalLocation: 'India', count: 1 },
//   { originalLocation: 'ES/Biscay', count: 1 },
//   { originalLocation: 'US/California', count: 6 },
//   { originalLocation: 'US/Washington', count: 1 }
// ];

type EnrichedBusinessLocationType = {
  originalLocation: string
  count: number
}

export interface ILocationsSection {
  locations: Array<string>
  enrichedBusinessLocations: Array<EnrichedBusinessLocationType>
}

function LocationsSection({ locations = [], enrichedBusinessLocations = [] }: ILocationsSection) {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h3 className={styles.summary}>
          <div className={styles.title}>
            <FormattedMessage {...messages.locations} />
          </div>
        </h3>
      </header>
      <div className={styles.content}>
        <div className={styles.filters}>
          <CheckboxGroup
            type='regular'
            name='locationFilters'
            options={enrichedBusinessLocations.map(({ originalLocation, count }) => `${originalLocation} (${count})`)}
            selections={[]}
            onChange={option => {}}
          />
        </div>
        <div className={styles.locations}>
          <div className={styles.title}>
            <FormattedMessage
              {...messages.addresses}
              values={{ count: locations ? locations.length : 0 }}
              tagName='span'
            />
          </div>
          {!!locations && locations.length === 1
            ? locations[0]
            : locations
                .filter(element => !!element)
                .map((element, index) => (
                  <li key={index} className={styles.listItem}>
                    {element}
                  </li>
                ))}
        </div>
      </div>
    </div>
  )
}

export default LocationsSection
